export var Microsoft365UserLicenseStatus;
(function (Microsoft365UserLicenseStatus) {
    Microsoft365UserLicenseStatus["Licensed"] = "licensed";
    Microsoft365UserLicenseStatus["Unlicensed"] = "unlicensed";
})(Microsoft365UserLicenseStatus || (Microsoft365UserLicenseStatus = {}));
